import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsGooglekeepComponent } from './simple-icons-googlekeep.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsGooglekeepComponent ],
    exports:      [ SimpleIconsGooglekeepComponent ],
    bootstrap:    []
})
export class SimpleIconsGooglekeepModule {}
